<section class="padding-reset" *ngIf="hasFieldOrEditable(rendering.fields.title) || hasFieldOrEditable(rendering.fields.body)">
    <div class="section-wrapper">
        <ng-container *ngIf="hasFieldOrEditable(rendering.fields.title)">
            <h4 class="header-content" *scRichText="rendering.fields.title"></h4>
        </ng-container>
        <xm-cms-text [customClass]="'marketing-grid-text-plan'" *ngIf="hasFieldOrEditable(rendering.fields.body)" class="medium-plus-body margin-reset text-spacing" [field]="rendering.fields.body"></xm-cms-text>
    </div>
</section>
